var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Order Form shows a form for a user to add input
import { keys } from "ramda";
import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import uuid from "uuid";
import { Countries } from "../../data";
import { Money } from "../../data/Money";
import { WebSocketMessage } from "../../serverConnection";
import CountrySelect from "../common/CountrySelect";
import CurrencySelect from "../common/CurrencySelect";
import EnterpriseSelect from "../common/EnterpriseSelect";
import InputField from "../common/InputField";
var validate = function (product) {
    var errors = {};
    if (product.name.length === 0) {
        errors.name = "Must not be empty";
    }
    if (product.locations <= 0) {
        errors.locations = "Must be greater 0";
    }
    if (product.price.amount < 0) {
        errors.price = "Must not be negative";
    }
    if (product.fee.amount < 0) {
        errors.fee = "Must not be negative";
    }
    if (product.premium.amount < 0) {
        errors.premium = "Must not be negative";
    }
    if (product.vat < 0) {
        errors.vat = "Must not be negative";
    }
    if (!Countries.includes(product.country)) {
        errors.country = "A country must be selected";
    }
    if (product.enterprise === "none") {
        errors.enterprise = "An enterprise must be chosen";
    }
    return errors;
};
export var ProductForm = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var _g = useState(props.match.params.id
        ? props.products.find(function (p) { return p.id === props.match.params.id; })
        : {
            id: uuid.v1(),
            name: "",
            locations: 0,
            price: new Money(0, "€ EUR"),
            premium: new Money(0, "€ EUR"),
            country: "DE",
            enterprise: "none",
            fee: new Money(0, "€ EUR"),
            created: new Date(),
            updated: new Date(),
            vat: 0,
        }), product = _g[0], setProduct = _g[1];
    var updateProduct = function () {
        props.send(WebSocketMessage("products", "update", product));
        props.history.push("/products");
    };
    var chosenEnterprise = props.enterprises.find(function (e) { return e.id === product.enterprise; });
    var errors = validate(product);
    return (React.createElement("div", { className: "container content" },
        React.createElement("h5", null, "Create product"),
        React.createElement("br", null),
        React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
            React.createElement("div", { className: "card-panel" },
                React.createElement(InputField, { label: "Product ID", type: "text", placeholder: "Country Code + Product Code", value: product.name, onChange: function (name) { return setProduct(__assign(__assign({}, product), { name: name })); }, meta: { touched: true, error: errors.name } }),
                React.createElement(InputField, { label: "Locations", type: "number", placeholder: "Number of devices", value: product.locations, onChange: function (locations) { return setProduct(__assign(__assign({}, product), { locations: Number.parseInt(locations, 10) })); }, meta: { touched: true, error: (_a = errors.locations) === null || _a === void 0 ? void 0 : _a.toString() } }),
                React.createElement(InputField, { label: "Price", type: "number", placeholder: "Price", value: product.price.amount, onChange: function (price) {
                        return setProduct(__assign(__assign({}, product), { price: __assign(__assign({}, product.price), { amount: Number.parseInt(price, 10) }) }));
                    }, meta: { touched: true, error: (_b = errors.price) === null || _b === void 0 ? void 0 : _b.toString() } }),
                React.createElement(InputField, { label: "Fee", type: "number", placeholder: "Fee", value: product.fee.amount, onChange: function (fee) {
                        return setProduct(__assign(__assign({}, product), { fee: __assign(__assign({}, product.fee), { amount: Number.parseInt(fee, 10) }) }));
                    }, meta: { touched: true, error: (_c = errors.fee) === null || _c === void 0 ? void 0 : _c.toString() } }),
                React.createElement(InputField, { label: "Premium", type: "number", placeholder: "Premium", value: product.premium.amount, onChange: function (premium) {
                        return setProduct(__assign(__assign({}, product), { premium: __assign(__assign({}, product.premium), { amount: Number.parseInt(premium, 10) }) }));
                    }, meta: { touched: true, error: (_d = errors.premium) === null || _d === void 0 ? void 0 : _d.toString() } }),
                React.createElement(InputField, { label: "VAT", type: "number", placeholder: "VAT in %", value: product.vat, onChange: function (vat) {
                        return setProduct(__assign(__assign({}, product), { vat: Number.parseInt(vat, 10) }));
                    }, meta: { touched: true, error: (_e = errors.vat) === null || _e === void 0 ? void 0 : _e.toString() } }),
                React.createElement(EnterpriseSelect, { value: product.enterprise, enterprises: props.enterprises, setEnterprise: function (id) {
                        var country = product.country;
                        var newEnterprise = props.enterprises.find(function (e) { return e.id === id; });
                        if (newEnterprise && !newEnterprise.countries.includes(country)) {
                            country = newEnterprise.countries[0];
                        }
                        setProduct(__assign(__assign({}, product), { enterprise: id, country: country }));
                    }, error: (_f = errors.enterprise) === null || _f === void 0 ? void 0 : _f.toString() }),
                React.createElement("div", null,
                    React.createElement(CountrySelect, { value: product === null || product === void 0 ? void 0 : product.country, onChange: function (e) { return setProduct(__assign(__assign({}, product), { country: e.target.value })); }, enterprises: props.enterprises, countries: chosenEnterprise === null || chosenEnterprise === void 0 ? void 0 : chosenEnterprise.countries }),
                    React.createElement(CurrencySelect, { value: product === null || product === void 0 ? void 0 : product.price.currency, onChange: function (e) {
                            return setProduct(__assign(__assign({}, product), { price: __assign(__assign({}, product === null || product === void 0 ? void 0 : product.price), { currency: e.target.value }), fee: __assign(__assign({}, product === null || product === void 0 ? void 0 : product.fee), { currency: e.target.value }), premium: __assign(__assign({}, product === null || product === void 0 ? void 0 : product.premium), { currency: e.target.value }) }));
                        } })),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(Link, { to: "/orders", className: "white btn-flat left red-text" }, "Cancel"),
                React.createElement("button", { type: "submit", disabled: keys(errors).length > 0, className: "teal btn-flat btn right white-text", onClick: function () { return updateProduct(); } },
                    props.match.params.id ? "Update " : "Create ",
                    "product"),
                React.createElement("br", null),
                React.createElement("br", null)))));
};
export default withRouter(ProductForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/products/ProductForm.tsx
// module id = 1276
// module chunks = 0